import { Box, Input, Typography } from "@mui/material";
import React from "react";
import { usePathContext } from "../PathInfo";
import { useTreeModifyContext } from "../TreeDataContext";

interface DimsEditorProps {
  value: number[];
}

export function DimsEditor(props: DimsEditorProps) {
  const { path } = usePathContext();
  const { saveChangesAtPath } = useTreeModifyContext();

  function onDimsXChanged(x: number) {
    saveChangesAtPath([x, props.value[1]], path);
  }

  function onDimsYChanged(y: number) {
    saveChangesAtPath([props.value[0], y], path);
  }

  if (props.value.length !== 2) {
    props.value = [100, 100];
  }

  return (
    <Box className="horizontal-flex">
      <Typography>Dimensions&nbsp;</Typography>
      <Typography>X:</Typography>
      <Input
        type="number"
        id="dims-x"
        value={props.value[0]}
        slotProps={{ input: { type: "number", min: 1, max: 1000 } }}
        onChange={(event) => {
          let value = parseInt(event.target.value);
          if (value !== undefined) {
            onDimsXChanged(value);
          }
        }}
      />
      <Typography>Y:</Typography>
      <Input
        type="number"
        id="dims-y"
        value={props.value[1]}
        slotProps={{ input: { type: "number", min: 1, max: 1000 } }}
        onChange={(event) => {
          let value = parseInt(event.target.value);
          if (value !== undefined) {
            onDimsYChanged(value);
          }
        }}
      />
    </Box>
  );
}
